import React, { useEffect, useRef } from 'react'

export type MobileTabItem = {
  key: string
  label: string
}

type Props = {
  activeKey: string
  onChange: (key: string) => void
  tabs: MobileTabItem[]
}

export default function MobileOrderTabBar({ activeKey, onChange, tabs }: Props) {
  const scrollRef = useRef<HTMLDivElement>(null)
  const btnRefs = useRef<Record<string, HTMLButtonElement | null>>({})

  const scrollActiveToCenter = (key: string) => {
    const container = scrollRef.current
    const btn = btnRefs.current[key]
    if (!container || !btn) return
    const targetLeft = btn.offsetLeft - (container.clientWidth - btn.offsetWidth) / 2
    container.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' })
  }

  useEffect(() => {
    scrollActiveToCenter(activeKey)
  }, [activeKey])

  return (
    <div className="mobile-order-tab-bar" ref={scrollRef} role="tablist">
      {tabs.map((tab) => {
        const active = tab.key === activeKey
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            ref={(el) => { btnRefs.current[tab.key] = el }}
            className={`mobile-order-tab-btn${active ? ' active' : ''}`}
            onClick={() => {
              if (tab.key !== activeKey) onChange(tab.key)
              scrollActiveToCenter(tab.key)
            }}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
